import {
  CLOSET_PATH,
  FLOOR_PATH,
  HANDING_PATH,
  LED_MIRRORS_PATH,
  MIRROR_CABINETS_PATH,
  MIRRORS_PATH,
  PEDESTAL_PATH,
  UNDER_WASHING_MACHINE_PATH,
  WITH_SINK
} from '@shared/constants/catalog';

export enum ROUTES {
  MAIN = '/',
  PERSONAL_DATA = '/polozhenie-ob-obrabotke-personalnyh-dannyh',
  PUBLIC_OFFER = '/publichnaya-oferta',
  PERSONAL_ACCOUNT = '/lichnyj-kabinet',
  ORDERS_HISTORY = `${ROUTES.PERSONAL_ACCOUNT}/istoriya-zakazov`,
  CART = '/korzina',
  FAVORITES = '/izbrannoe',
  COMPARISON = '/sravnenie',
  COOKIES_POLICY = '/politika-obrabotki-kuki',
  CONSENT_PERSONAL_DATA = '/soglasie-na-obrabotku-personalnyh-dannyh',
  CONSENT_PERSONAL_DATA_METRIC = '/soglasie-na-obrabotku-personalnyh-dannyh-sobiraemyh-metricheskimi-programmami',
  USER_AGREEMENT = '/polzovatelskoe-soglashenie',
  PLACING_ORDER = '/oformlenie-zakaza',
  CONTACTS = '/kontakty',
  ABOUT_COMPANY = '/o-kompanii',
  WARRANTY = '/garantiya',
  SPLIT = '/chto-takoe-split',
  QUESTION_ANSWER = '/vopros-otvet',
  DELIVERY_AND_PAYMENT = '/dostavka-i-oplata',
  EXPLOITATION = '/ekspluataciya',
  BLOG = '/poleznye-stati',
  CATALOG = '/catalog',
  PRODUCT_CERTS = '/download/product-certs',
  PEDESTAL = `${CATALOG}/${PEDESTAL_PATH}`,
  MIRRORS = `${CATALOG}/${MIRRORS_PATH}`,
  CLOSET = `${CATALOG}/${CLOSET_PATH}`,
  WITH_SINK_PEDESTAL = `${PEDESTAL}/${WITH_SINK}`,
  HANDING_PEDESTAL = `${PEDESTAL}/${HANDING_PATH}`,
  FLOOR_PEDESTAL = `${PEDESTAL}/${FLOOR_PATH}`,
  UNDER_WASHING_MACHINE_PEDESTAL = `${PEDESTAL}/${UNDER_WASHING_MACHINE_PATH}`,
  HANDING_CLOSET = `${CLOSET}/${HANDING_PATH}`,
  FLOOR_CLOSET = `${CLOSET}/${FLOOR_PATH}`,
  UNDER_WASHING_MACHINE_CLOSET = `${CLOSET}/${UNDER_WASHING_MACHINE_PATH}`,
  LED_MIRRORS = `${MIRRORS}/${LED_MIRRORS_PATH}`,
  MIRROR_CABINETS = `${MIRRORS}/${MIRROR_CABINETS_PATH}`,
  SEARCH = '/search'
}
